import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';

/* ── Modal Términos y Condiciones ── */
const TermsModal = ({ onClose }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
    {/* Overlay */}
    <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />

    {/* Card */}
    <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[85vh] flex flex-col overflow-hidden">

      {/* Header */}
      <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 bg-gray-50 rounded-t-2xl flex-shrink-0">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-brand-600 rounded-lg flex items-center justify-center">
            <svg className="w-4 h-4 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/>
            </svg>
          </div>
          <div>
            <h2 className="font-bold text-gray-900 text-sm leading-tight">Términos y Condiciones</h2>
            <p className="text-gray-400 text-xs">Desarrollo RD</p>
          </div>
        </div>
        <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-200 transition-colors text-gray-400 hover:text-gray-600">
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>

      {/* Body scrollable */}
      <div className="overflow-y-auto px-6 py-5 flex-1 text-sm text-gray-600 space-y-5 leading-relaxed">

        <section>
          <h3 className="font-bold text-gray-900 text-xs uppercase tracking-wider mb-2 text-brand-600">1. Naturaleza del Servicio</h3>
          <p>Desarrollo RD proporciona una plataforma tecnológica (software como servicio) diseñada para la gestión administrativa de talleres automotrices. El usuario reconoce que Desarrollo RD no es una entidad prestadora de servicios automotrices, ni actúa como intermediario en la relación técnica o comercial entre El Taller y sus clientes finales.</p>
        </section>

        <section>
          <h3 className="font-bold text-gray-900 text-xs uppercase tracking-wider mb-2 text-brand-600">2. Independencia y Autonomía</h3>
          <p className="mb-2">Cada taller registrado opera de manera totalmente autónoma e independiente. El Taller es el único responsable de:</p>
          <ul className="space-y-1 pl-4">
            <li className="flex items-start gap-2"><span className="text-brand-500 mt-0.5 flex-shrink-0">•</span>La calidad de los trabajos mecánicos realizados.</li>
            <li className="flex items-start gap-2"><span className="text-brand-500 mt-0.5 flex-shrink-0">•</span>El cumplimiento de garantías sobre repuestos y mano de obra.</li>
            <li className="flex items-start gap-2"><span className="text-brand-500 mt-0.5 flex-shrink-0">•</span>La seguridad de los vehículos bajo su custodia.</li>
            <li className="flex items-start gap-2"><span className="text-brand-500 mt-0.5 flex-shrink-0">•</span>El cumplimiento de las normas ambientales, laborales y comerciales vigentes en su jurisdicción.</li>
          </ul>
        </section>

        <section>
          <h3 className="font-bold text-gray-900 text-xs uppercase tracking-wider mb-2 text-brand-600">3. Exoneración de Responsabilidad</h3>
          <p className="mb-2">Desarrollo RD, sus propietarios y desarrolladores, no serán responsables bajo ninguna circunstancia por:</p>
          <ul className="space-y-1 pl-4">
            <li className="flex items-start gap-2"><span className="text-brand-500 mt-0.5 flex-shrink-0">•</span><span><strong className="text-gray-700">Daños Materiales o Personales:</strong> Cualquier daño ocurrido dentro de las instalaciones del taller o derivados de un servicio mecánico defectuoso.</span></li>
            <li className="flex items-start gap-2"><span className="text-brand-500 mt-0.5 flex-shrink-0">•</span><span><strong className="text-gray-700">Pérdida de Información:</strong> El Taller es responsable de mantener sus propios respaldos de información sensible.</span></li>
            <li className="flex items-start gap-2"><span className="text-brand-500 mt-0.5 flex-shrink-0">•</span><span><strong className="text-gray-700">Lucro Cesante:</strong> No nos hacemos responsables por pérdidas económicas debidas a fallos temporales en la plataforma.</span></li>
            <li className="flex items-start gap-2"><span className="text-brand-500 mt-0.5 flex-shrink-0">•</span><span><strong className="text-gray-700">Uso de la Landing Page:</strong> El Taller es el único responsable del contenido, fotos, ofertas y veracidad de la información publicada.</span></li>
          </ul>
        </section>

        <section>
          <h3 className="font-bold text-gray-900 text-xs uppercase tracking-wider mb-2 text-brand-600">4. Uso de la Plataforma y Acceso</h3>
          <p className="mb-2">El acceso al software está sujeto a la aprobación previa de Desarrollo RD. Nos reservamos el derecho de suspender o cancelar cuentas que:</p>
          <ul className="space-y-1 pl-4">
            <li className="flex items-start gap-2"><span className="text-brand-500 mt-0.5 flex-shrink-0">•</span>Incumplan con los pagos acordados.</li>
            <li className="flex items-start gap-2"><span className="text-brand-500 mt-0.5 flex-shrink-0">•</span>Hagan un uso indebido de la plataforma (spam, contenido ilegal, etc.).</li>
            <li className="flex items-start gap-2"><span className="text-brand-500 mt-0.5 flex-shrink-0">•</span>Utilicen el software para actividades fraudulentas.</li>
          </ul>
        </section>

        <section>
          <h3 className="font-bold text-gray-900 text-xs uppercase tracking-wider mb-2 text-brand-600">5. Propiedad Intelectual</h3>
          <p>El software, diseño, código y logos de la plataforma son propiedad exclusiva de Desarrollo RD. El Taller recibe una licencia de uso no exclusiva y revocable mientras dure su suscripción.</p>
        </section>

        <section>
          <h3 className="font-bold text-gray-900 text-xs uppercase tracking-wider mb-2 text-brand-600">6. Protección de Datos (Ley 1581 de 2012)</h3>
          <p>El Taller, al registrar datos de sus clientes finales, actúa como Responsable del Tratamiento de Datos. Desarrollo RD actúa únicamente como Encargado del Tratamiento, limitándose a almacenar y procesar la información según las instrucciones del software.</p>
        </section>

        <section>
          <h3 className="font-bold text-gray-900 text-xs uppercase tracking-wider mb-2 text-brand-600">7. Modificaciones</h3>
          <p>Desarrollo RD se reserva el derecho de actualizar estos términos en cualquier momento. El uso continuado de la aplicación tras dichos cambios constituye la aceptación de los nuevos términos.</p>
        </section>
      </div>

      {/* Footer */}
      <div className="px-6 py-4 border-t border-gray-100 bg-gray-50 rounded-b-2xl flex-shrink-0">
        <button onClick={onClose} className="w-full py-2.5 bg-brand-600 hover:bg-brand-500 text-white font-bold rounded-xl text-sm transition-colors">
          Entendido, cerrar
        </button>
      </div>
    </div>
  </div>
);

const RegistroTaller = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    slug: '',
    phone: '',
    address: '',
    city: '',
    advisor_code: '',
    slot_duration_min: 60,
    opening_time: '08:00:00',
    closing_time: '18:00:00'
  });

  const handleNameChange = (e) => {
    const nameValue = e.target.value;

    // Generación de slug limpia para URLs profesionales
    const slugValue = nameValue
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^\w\s-]/g, '')
      .trim()
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');

    setFormData({
      ...formData,
      name: nameValue,
      slug: slugValue
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.slug) {
        alert("El nombre del negocio no es valido para generar una URL.");
        return;
    }

    if (!termsAccepted) {
        alert("Debes aceptar los Términos y Condiciones para continuar.");
        return;
    }

    setLoading(true);

    try {
      // 1. Insertamos el nuevo taller en la tabla 'workshops'
      const { data, error } = await supabase
        .from('workshops')
        .insert([
          {
            name: formData.name,
            slug: formData.slug,
            phone: formData.phone,
            address: formData.address,
            city: formData.city,
            advisor_code: formData.advisor_code || '0000',
            slot_duration_min: parseInt(formData.slot_duration_min) || 60,
            opening_time: formData.opening_time,
            closing_time: formData.closing_time,
            is_active: true
          }
        ])
        .select(); // IMPORTANTE: Pedimos que devuelva el registro creado (con su ID)

      if (error) throw error;

      if (data && data.length > 0) {
        // 2. EXTRAEMOS EL ID ÚNICO (UUID)
        const nuevoTallerId = data[0].id;

        // 3. REDIRECCIÓN AL SETUP DE LA LANDING PAGE
        console.log("Taller creado con éxito. Redirigiendo a setup:", nuevoTallerId);
        navigate(`/setup/${nuevoTallerId}`);
      }

    } catch (error) {
      console.error("Error detallado en Supabase:", error);
      alert('Error en Desarrollo RD: ' + (error.message || 'No se pudo crear el taller. Revisa la consola.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <section id="contacto" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="text-brand-600 font-semibold tracking-wide uppercase text-sm mb-2">Empieza Hoy</h2>
          <h3 className="text-3xl md:text-4xl font-bold text-dark mb-4">Registra tu negocio en minutos</h3>
          <p className="text-gray-500 text-lg">Completa el formulario y recibe acceso inmediato a tu panel de gestion y tu Landing Page propia.</p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center max-w-5xl mx-auto">

          {/* Left — benefits */}
          <div>
            <h4 className="text-2xl font-bold text-dark mb-8">Lo que obtienes desde el dia uno</h4>
            <ul className="space-y-6">
              <li className="flex items-start gap-4">
                <div className="flex-shrink-0 w-12 h-12 bg-brand-100 rounded-xl flex items-center justify-center">
                  <svg className="w-6 h-6 text-brand-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>
                </div>
                <div>
                  <h5 className="font-bold text-dark mb-1">Tu propia Landing Page</h5>
                  <p className="text-gray-500 text-sm">Pagina web automatica con tu slug, colores y servicios propios. Presencia digital inmediata para cualquier nicho.</p>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <div className="flex-shrink-0 w-12 h-12 bg-brand-100 rounded-xl flex items-center justify-center">
                  <svg className="w-6 h-6 text-brand-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/><polyline points="9 16 11 18 15 14"/></svg>
                </div>
                <div>
                  <h5 className="font-bold text-dark mb-1">Agenda Online Activada</h5>
                  <p className="text-gray-500 text-sm">Tus clientes agendan desde la web y tú ves todo en tiempo real en tu panel de administrador.</p>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <div className="flex-shrink-0 w-12 h-12 bg-brand-100 rounded-xl flex items-center justify-center">
                  <svg className="w-6 h-6 text-brand-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"/><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>
                </div>
                <div>
                  <h5 className="font-bold text-dark mb-1">Inventario y Facturación</h5>
                  <p className="text-gray-500 text-sm">Control total de stock, asignacion directa a ordenes de trabajo y facturacion con un clic.</p>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <div className="flex-shrink-0 w-12 h-12 bg-brand-100 rounded-xl flex items-center justify-center">
                  <svg className="w-6 h-6 text-brand-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
                </div>
                <div>
                  <h5 className="font-bold text-dark mb-1">CRM e Historial de Clientes</h5>
                  <p className="text-gray-500 text-sm">Base de datos de clientes y servicios para fidelizar y hacer seguimiento personalizado.</p>
                </div>
              </li>
            </ul>
          </div>

          {/* Right — form */}
          <div className="bg-white rounded-3xl shadow-2xl shadow-gray-200/80 border border-gray-100 p-8 md:p-10">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-10 h-10 bg-brand-600 rounded-xl flex items-center justify-center">
                <svg className="w-5 h-5 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>
              </div>
              <div>
                <h4 className="font-bold text-dark text-lg leading-tight">Datos de tu Negocio</h4>
                <p className="text-gray-400 text-xs">Todos los campos son requeridos</p>
              </div>
            </div>

            <form onSubmit={handleSubmit} className="space-y-5">

              {/* Nombre */}
              <div>
                <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1.5">Nombre del Negocio</label>
                <input
                  type="text"
                  required
                  className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-dark placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition-all text-sm"
                  value={formData.name}
                  onChange={handleNameChange}
                  placeholder="Ej: Salon Bella, Clinica Vida, Gym Power..."
                />
              </div>

              {/* Slug preview */}
              <div>
                <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1.5">Tu URL de Agenda</label>
                <div className="flex items-center px-4 py-3 bg-brand-50 border border-brand-200 rounded-xl">
                  <span className="text-gray-400 text-xs">agenda.../</span>
                  <span className="text-brand-600 font-bold text-xs ml-1">{formData.slug || 'url-automatica'}</span>
                </div>
              </div>

              {/* Teléfono + Ciudad */}
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1.5">Teléfono</label>
                  <input
                    type="text"
                    required
                    className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-dark placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition-all text-sm"
                    value={formData.phone}
                    placeholder="300 000 0000"
                    onChange={(e) => setFormData({...formData, phone: e.target.value})}
                  />
                </div>
                <div>
                  <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1.5">Ciudad / Municipio</label>
                  <input
                    type="text"
                    required
                    className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-dark placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition-all text-sm"
                    value={formData.city}
                    placeholder="Ej: Bogotá, Medellín..."
                    onChange={(e) => setFormData({...formData, city: e.target.value})}
                  />
                </div>
              </div>

              {/* Dirección */}
              <div>
                <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1.5">Dirección</label>
                <input
                  type="text"
                  required
                  className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-dark placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition-all text-sm"
                  value={formData.address}
                  placeholder="Calle 10 # 5-23, Chía"
                  onChange={(e) => setFormData({...formData, address: e.target.value})}
                />
              </div>

              {/* Código de Vendedor (Opcional) */}
              <div>
                <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1.5">Código de Vendedor (Opcional)</label>
                <input
                  type="text"
                  className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-dark placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition-all text-sm"
                  value={formData.advisor_code}
                  placeholder="Ej: 0007"
                  onChange={(e) => setFormData({...formData, advisor_code: e.target.value})}
                />
              </div>

              {/* Submit */}
              <button
                type="submit"
                disabled={loading}
                className={`w-full py-4 rounded-xl font-bold text-white text-base transition-all transform active:scale-95 flex items-center justify-center gap-2 mt-2 ${
                  loading
                    ? 'bg-gray-300 cursor-not-allowed'
                    : 'bg-brand-600 hover:bg-brand-500 shadow-lg shadow-brand-600/30'
                }`}
              >
                {loading ? (
                  <>
                    <svg className="w-5 h-5 animate-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="2" x2="12" y2="6"/><line x1="12" y1="18" x2="12" y2="22"/><line x1="4.93" y1="4.93" x2="7.76" y2="7.76"/><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"/><line x1="2" y1="12" x2="6" y2="12"/><line x1="18" y1="12" x2="22" y2="12"/><line x1="4.93" y1="19.07" x2="7.76" y2="16.24"/><line x1="16.24" y1="7.76" x2="19.07" y2="4.93"/></svg>
                    Activando tu negocio...
                  </>
                ) : (
                  <>
                    Activar mi Negocio ahora
                    <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
                  </>
                )}
              </button>

              {/* Checkbox términos */}
              <label className={`flex items-start gap-3 cursor-pointer group pt-1 p-3 rounded-xl border-2 transition-all ${
                termsAccepted ? 'border-brand-400 bg-brand-50' : 'border-gray-200 hover:border-gray-300'
              }`}>
                <div className="relative flex-shrink-0 mt-0.5">
                  <input
                    type="checkbox"
                    className="sr-only"
                    checked={termsAccepted}
                    onChange={(e) => setTermsAccepted(e.target.checked)}
                  />
                  <div className={`w-5 h-5 rounded flex items-center justify-center border-2 transition-all ${
                    termsAccepted ? 'bg-brand-600 border-brand-600' : 'border-gray-300 bg-white'
                  }`}>
                    {termsAccepted && (
                      <svg className="w-3 h-3 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="20 6 9 17 4 12"/>
                      </svg>
                    )}
                  </div>
                </div>
                <span className="text-xs text-gray-500 leading-relaxed">
                  He leido y acepto los{' '}
                  <button
                    type="button"
                    onClick={(e) => { e.preventDefault(); setShowTerms(true); }}
                    className="text-brand-600 font-semibold hover:underline"
                  >
                    Terminos y Condiciones
                  </button>
                  {' '}de Desarrollo RD. Entiendo que cada negocio es responsable autonomo de su operacion.
                </span>
              </label>
            </form>
          </div>

        </div>
      </div>
    </section>

    {/* Modal términos */}
    {showTerms && <TermsModal onClose={() => setShowTerms(false)} />}
    </>
  );
};

export default RegistroTaller;
